import * as React from 'react';
import {Dialog, DialogTitle, TextField, withStyles, WithStyles, ImageList} from '@material-ui/core';
import {displayErrorMessage} from '@services/user/user.actions';
import AddIcon from '@material-ui/icons/Add';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import {connect} from 'react-redux';
import {IFamilyMember} from '@app-types/websocket/family.types';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {FamilyMemberType} from "@services/family/family.constants";
import {EcoRepeat, IEcoAgreement, IEcoSplit, INewEcoAgreement, IUpdateEcoAgreement, EcoAgreementStatus, IEcoSplitSetting} from "@app-types/websocket/economy.types";
import ImgAvatar from "@components/common/avatar/ImgAvatar";
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import DeleteIcon from '@material-ui/icons/DeleteForeverTwoTone';
import {EditOutlined, Repeat} from "@material-ui/icons";
import * as FileActions from '@services/file/file.actions';
import CordovaContext from '../../cordovaContext';
import {
  AmountLabel,
  BoxedRow,
  Col,
  CustomDialogContent,
  CustomSelect,
  CustomSelectInverted,
  CustomTextField,
  DialogTop,
  PercentageLabel,
  Row,
  StyledButton,
  StyledInputAdornment,
  StyledLabel,
  StyledSlider,
  convertSliderValueToPercentage,
  convertPercentageToSliderValue,
  dialogStyles,
  CustomTextFieldInvertedP,
  CustomCheckbox,
  NoPrice
} from './DialogComponens';
import { IFileDesc, IStuffBeingUploaded, IFinishedUpload, IUploadFile } from '@app-types/websocket/file.types';
import ListImage from './sharedcomponents/ListImage';
import ChatButton from './ChatButton';
import { ChatType } from '@app-types/websocket/chat.types';
import { buttonContainedLarge, styleColors } from 'src/main.style';
import { getCanvasBlobFromImageFile, getCanvasDataURLFromFile, handleBlobUpload, handleImageUpload, fileToBase64 } from '@helpers/uploadHelper';
import AvatarEditor from 'react-avatar-editor';

const tn = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof dialogStyles>{
  isOpen: boolean;
  isRequest: boolean;
  onClose: () => void;
  onCreateNew: (values:INewEcoAgreement) => void;
  onEdit: (values:IUpdateEcoAgreement) => void;
  onDelete: (agreementId:number, future:boolean) => void;
  userId: number;
  family: IFamilyMember[];
  existingAgreement?: IEcoAgreement;
  currency:string;
  settings:IEcoSplitSetting[];

  uploadingFiles: IStuffBeingUploaded[];
  uploadedFiles: IFinishedUpload[];
  uploadFile:(file: IUploadFile) => void;
  uploadedFileUsed: (file: number) => void;
  removeStoredFile: (file: number) => void;
  waitForAgreementChat:(id:number) => void;
  displayErrorMessage: (msg: string) => void;
}

interface IState {
  values: INewEcoAgreement;
  showDescription: boolean;
  showImages: boolean;
  setPrice:boolean;
  previousFiles: IFileDesc[];
  showConfirmDelete: boolean;
  zoomImage:string|undefined;
  internalImages:number[];
  internalDataUrl:string[];
  loadedImageUrls:string[];
  saveClicked:boolean;
}

class AgreementDialog extends React.Component<IProps, IState> {

  private editorRef1: React.RefObject<AvatarEditor> = React.createRef();
  private editorRef2: React.RefObject<AvatarEditor> = React.createRef();
  private editorRef3: React.RefObject<AvatarEditor> = React.createRef();


  constructor(props: IProps) {
    super(props);
    const {existingAgreement} = this.props;

    this.state = {
      ...this.newState(existingAgreement),
    };
    
  }

  public componentDidUpdate(oldProps:IProps) {
    if (this.state.saveClicked && this.props.uploadedFiles !== oldProps.uploadedFiles) {

      let uploadedFilesCount = 0;
      for (const internalId of this.state.internalImages) {
        if (this.props.uploadedFiles.findIndex((u) => u.internalId === internalId) !== -1) {
          uploadedFilesCount += 1;
        }
      }

      if (uploadedFilesCount === this.state.internalDataUrl.length) {
        this.save();
      } else {
        if (uploadedFilesCount === 1 && this.editorRef2.current) {
          this.upload(this.editorRef2.current, 800,800);
        } else if (uploadedFilesCount === 2 && this.editorRef3.current) {
          this.upload(this.editorRef3.current, 800,800);
        } 
      }
    }
    if (this.props.isOpen === true && oldProps.isOpen === false) {
      const {existingAgreement} = this.props;
      this.setState(this.newState(existingAgreement));
    }
  }

  public newState(existingAgreement: IEcoAgreement|undefined):IState {
    if (existingAgreement !== undefined && existingAgreement.pendingChange !== undefined 
      && existingAgreement.pendingChange.status === EcoAgreementStatus.AWAITING_RESPONSE) {
      return {
        showImages: (!!existingAgreement.images && existingAgreement.images.length > 0),
        showDescription: (!!existingAgreement.description && existingAgreement.description.length > 0),
        values: {
          title: existingAgreement.title,
          children: existingAgreement.children,
          amount: existingAgreement.pendingChange.amount,
          currency: existingAgreement.pendingChange.currency,
          description: existingAgreement.description,
          images: [], 
          responsible: existingAgreement.responsible,
          repeat: existingAgreement.repeat,
          split: existingAgreement.pendingChange.split,
        },
        internalImages:[],
        internalDataUrl:[],
        loadedImageUrls:[],
        saveClicked:false,
        previousFiles: existingAgreement.images || [],
        setPrice:(existingAgreement.pendingChange.amount !== undefined && existingAgreement.pendingChange.amount !== 0),
        showConfirmDelete:false,
        zoomImage:undefined,
      };
    } else if (existingAgreement) {
      return {
        showImages: (!!existingAgreement.images && existingAgreement.images.length > 0),
        showDescription: (!!existingAgreement.description && existingAgreement.description.length > 0),
        values: {
          title: existingAgreement.title,
          children: existingAgreement.children,
          amount: existingAgreement.amount,
          currency: existingAgreement.currency,
          description: existingAgreement.description,
          images: [], 
          responsible: existingAgreement.responsible,
          repeat: existingAgreement.repeat,
          split: existingAgreement.split,
        },
        internalImages:[],
        internalDataUrl:[],
        loadedImageUrls:[],
        saveClicked:false,
        previousFiles: existingAgreement.images || [],
        setPrice:(existingAgreement.amount !== undefined && existingAgreement.amount !== 0),
        showConfirmDelete:false,
        zoomImage:undefined,
      };
    } else {

      const split = (this.props.settings.length > 0)
        ?(this.props.settings[this.props.settings.length -1].split.map((sp) => ({accountId:sp.accountId, percentage:sp.percentage})))
        :this.props.family.filter(m => m.role === FamilyMemberType.PARENT)
        .map(m => ({
          accountId: m.id,
          percentage: 50,
        }));

      const achild = this.props.family.find(m => m.role === FamilyMemberType.CHILD);
      return {
        showImages: false,
        showDescription: false,
        values: {
          title: '',
          children: (achild?[achild.id]:[]),
          amount: 0,
          currency: this.props.currency,
          description: '',
          images: [],
          responsible: [],
          repeat: this.props.isRequest?EcoRepeat.ONCE:EcoRepeat.MONTHLY,
          split,
        },
        internalImages:[],
        internalDataUrl:[],
        loadedImageUrls:[],
        saveClicked:false,
        previousFiles:[],
        setPrice:true,
        showConfirmDelete:false,
        zoomImage:undefined,
      };
    }
  }

  public render() {
    const { isOpen, onClose } = this.props;
    const { values, showImages, showDescription, previousFiles } = this.state;

    let myPercentage = 50;
    let coparentName = "Unknown";
    for (const split of values.split) {
      if (split.accountId === this.props.userId) {
        myPercentage = split.percentage;
      } else {
        coparentName = tn.familyMemberName(split.accountId,this.props.family);
      }
    }

    let title = tn.lang.purchaseRecurringNew;
    if (this.props.isRequest) {
      title = tn.lang.purchaseProposalNew;
    }
    if (this.props.existingAgreement !== undefined ) {
      if (this.props.existingAgreement.closed === true) {
        title = tn.lang.purchaseProposalClosed;
      } else if(this.props.existingAgreement.status === EcoAgreementStatus.DELETED 
        || this.props.existingAgreement.status === EcoAgreementStatus.REJECTED) {
        title = tn.lang.purchaseProposalDeleted;
      } else {
        title = tn.lang.purchaseProposalEdit;
      }
    }
    let buttonText = tn.lang.send;
    if (this.state.saveClicked) {
      buttonText = tn.lang.uploading;
    } else if (this.props.existingAgreement !== undefined && this.props.existingAgreement.closed === true) {
      buttonText = tn.lang.done;
    } else if (this.props.existingAgreement !== undefined) {
      buttonText = tn.lang.update;
    }

    const isCordovaApp = this.context;

    let fileUrl = ""; 
    let fileTitle = "";
    if (this.props.existingAgreement !== undefined) {
      fileTitle = this.props.existingAgreement.title;
    }
    if (this.state.zoomImage !== undefined) {
      fileUrl = this.state.zoomImage;  
    }

    return (
      <>
      <Dialog
        open={isOpen}
        onClose={() => {this.cleanup(); onClose();}}
        fullWidth={true}
      >
        <DialogTop>
          <DialogTitle>{title}</DialogTitle>
          <IconButton onClick={() => {this.cleanup(); onClose();}}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
          <CustomDialogContent>
            <Row style={{ alignItems: 'center', gap: '16px', }}>
              <Col style={{ flex: 1 }}>
                  <CustomTextField
                    name="title"
                    value={values.title}
                    onChange={this.handleChange}
                    placeholder={tn.lang.title}
                    InputProps={{ disableUnderline: true }}
                    InputLabelProps={{ shrink: false }}
                    autoFocus={(values.title.trim().length>0?false:true)}
                    tabIndex={0}
                  />
              </Col>
              <Col style={{position:'relative'}}>
                  <StyledLabel htmlFor="children" style={{position: 'absolute', top: '2px', zIndex:2, left:'2px'}}>
                    {tn.lang.agreementForWho}
                  </StyledLabel>
                  <CustomSelect
                    name="children"
                    value={this.getSelectedChildrenOption(values.children)}
                    displayEmpty={true}
                    onChange={this.handleChildrenChange}
                    disableUnderline={true}
                    data={this.childrenDropdownData()}
                  />
              </Col>
            </Row>
            
              <BoxedRow>
                <Col style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', minWidth: 110 }}>
                  <StyledLabel htmlFor="setPrice">{tn.lang.agreementEstimatePrice}
                    <CustomCheckbox color="default" id="setPrice" checked={this.state.setPrice} 
                      onClick={() => this.setState({setPrice:!this.state.setPrice})}/>
                  </StyledLabel>
                </Col>
                <Col>
                {this.state.setPrice
                  ?<CustomTextFieldInvertedP
                    name="amount"
                    id="amount"
                    value={(values.amount === undefined || values.amount===0)?"":values.amount}
                    placeholder={(values.amount === undefined || values.amount===0)?"0":undefined}
                    onChange={this.handleChange}
                    type="number"
                    inputMode="numeric"
                    tabIndex={1}
                    autoComplete="off"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (<StyledInputAdornment position="end" disableTypography={true}>{this.props.currency}</StyledInputAdornment>),
                    }}
                    InputLabelProps={{ shrink: false }}
                  />
                  :<NoPrice>{tn.lang.agreementNoPrice}</NoPrice>
                }
                  
                </Col>
              </BoxedRow>
            <Col>
              <StyledLabel style={{fontSize:'10px', lineHeight:'10px'}}>
                {tn.lang.agreementSplitQuestion}
              </StyledLabel>
              <Row style={{ justifyContent: 'space-evenly' }}>
                <Col style={{ alignItems: 'center', minWidth: '33%' }}>
                  {(values.amount !== undefined && values.amount > 0) && (
                    <AmountLabel>{tn.formatNumber((values.amount * (100-myPercentage))/100, this.props.currency)}</AmountLabel>
                  )}
                  <PercentageLabel
                    onClick={() => this.handlePercentageClick('coparent')}
                    style={{color:styleColors.greyDark2, cursor:'pointer', userSelect:'none'}}>
                    {100-myPercentage} %
                  </PercentageLabel>
                  <StyledLabel style={{margin: '-4px 0px'}}>{tn.lang.agreementCoparentPart(coparentName)}</StyledLabel>
                </Col>
                <Col style={{ alignItems: 'center', minWidth: '33%' }}>
                  {(values.amount !== undefined && values.amount > 0) && (
                    <AmountLabel>{tn.formatNumber((values.amount * myPercentage)/100, this.props.currency)}</AmountLabel>
                  )}
                  <PercentageLabel
                    onClick={() => this.handlePercentageClick('mine')}
                    style={{color:styleColors.greyDark2, cursor:'pointer', userSelect:'none'}}>
                    {myPercentage} %
                  </PercentageLabel>
                  <StyledLabel style={{margin: '-4px 0px'}}>{tn.lang.agreementMyPartSet}</StyledLabel>
                </Col>
              </Row>
            </Col>
            <Col>
              <StyledSlider
                name="split"
                value={convertPercentageToSliderValue(myPercentage)}
                onChange={this.handleSliderChange}
                min={0}
                max={36}
                step={1}
              />
            </Col>

            
              <BoxedRow style={{ flex: 1 }}>
                  <StyledLabel htmlFor="repeat" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1, gap:'8px', }}>
                    <Repeat style={{fontSize:'10px'}} /> <span>{tn.lang.repeat}</span>
                  </StyledLabel>
                  <Col>
                  {(this.props.existingAgreement === undefined || this.props.existingAgreement.repeat !== EcoRepeat.ONCE)
                    ?<CustomSelectInverted
                      name="repeat"
                      value={values.repeat}
                      onChange={this.handleChange}
                      displayEmpty={true}
                      disableUnderline={true}
                      data={Object.values(EcoRepeat).map((option: string) => ({value:option, element:<>{tn.lang.repeatOption(option)}</>}))}
                    /> 
                    :<div style={{fontSize: '12px',background: styleColors.white,fontWeight: 500,
                      padding: '10px 13px',color: styleColors.greyMedium1}}>
                      {tn.lang.repeatOption(this.props.existingAgreement.repeat)}
                    </div>
                  }
                  </Col>
              </BoxedRow>
            <BoxedRow>
              <Col style={{ flex: 1 }}>
                <StyledLabel>{tn.lang.agreementResponsible}</StyledLabel>
                <Row>
                  {this.props.family
                    .filter((member) => member.role === FamilyMemberType.PARENT)
                    .map((member) => (
                      <div key={member.id} onClick={() => this.handleResponsibleChange(member.id)}>
                        {this.getAvatar(member, 40, (!values.responsible.includes(member.id)))}
                      </div>
                    ))}
                </Row>
              </Col>
              <Col style={{ justifyContent: 'center' }}>
                <Row>
                  <StyledButton onClick={this.toggleDescription} style={showDescription
                    ?{backgroundColor: 'transparent', boxShadow: `inset 1px 1px 4px ${styleColors.greyDark2}`}:{backgroundColor: styleColors.white}}>
                    <EditOutlined />
                  </StyledButton>
                  {this.renderAddImageButton(showImages, isCordovaApp)}
                </Row>
              </Col>
            </BoxedRow>
            {showDescription && (
              <BoxedRow>
                <Col style= {{flex:1}}>
                    <TextField
                      name="description"
                      value={values.description}
                      placeholder={tn.lang.labelDescription}
                      onChange={this.handleChange}
                      multiline={true}
                      InputProps={{ disableUnderline: true }}
                      InputLabelProps={{ shrink: false }}
                    />
                </Col>
              </BoxedRow>
            )}
            <BoxedRow style={(showImages || previousFiles.length > 0)?{}:{opacity:0,height: 0,marginTop:'-8px',padding: 0}}>
              <Col style={{flex:1}}>
                <ImageList rowHeight={100} cols={3}>
                  {this.state.previousFiles.map((file, index) => 
                    <ListImage serverFile={file} key={index} zoomImage={(url:string) => this.setState({zoomImage:url})}
                      removeImage={this.removeImage}/>)}
                  {this.state.internalDataUrl.map((url:string, index:number) => 
                    <li style={{ width: '29%', height: '104px', padding: '2px', position:'relative'}} key={""+index}>
                      <AvatarEditor
                        ref={index === 0?this.editorRef1:(index === 1?this.editorRef2:(index === 2?this.editorRef3:undefined))}
                        image={url}
                        style={{ width: "70px", height: "100px", maxWidth: "70px", maxHeight: "100px" }}
                        border={0}
                        width={560}
                        height={800}
                        borderRadius={0}
                        color={[255, 255, 255, 1]}
                        scale={1}
                        rotate={0}
                        onLoadSuccess={() => this.imageLoaded(url)}
                        onLoadFailure={() => this.imageLoadFailed(url)}
                      />
                      <IconButton style={{    position: 'absolute',right: '-4px',top: '-4px',backgroundColor: styleColors.greyLight2,padding: '5px',}}
                        onClick={() => {const internalDataUrl = this.state.internalDataUrl.slice();
                          internalDataUrl.splice(index,1);
                          const loadedImageUrls = this.state.loadedImageUrls.filter(u => internalDataUrl.includes(u));
                          this.setState({internalDataUrl, loadedImageUrls})}}>
                        <DeleteIcon style={{fill:styleColors.coral800, fontSize:'18px'}} />
                      </IconButton>
                    </li>)}
                    {(this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length
                        +this.state.internalDataUrl.length) < 3 && !this.state.saveClicked && 
                      <div key={"add"} className={this.props.classes.listItemItem} style={{height: '100px', minWidth: '29%', 
                        display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <label htmlFor="add-file-2" className={this.props.classes.smallAddButton} >
                          <input type="file"  multiple={false } style = {{opacity: 0, position: 'absolute', width:'50px', height:'50px'}}
                            id={"add-file-2"} onChange={this.parseFile} accept="capture=camera,image/*"/>
                          <AddIcon style={{fill:styleColors.white}} />
                        </label>
                      </div>}
                  </ImageList>
              </Col>
            </BoxedRow>
          </CustomDialogContent>
          <Row style={{justifyContent: 'space-between', alignItems: 'center', padding: '0px 24px 20px'}}>
            {(this.props.existingAgreement !== undefined && this.props.existingAgreement.closed === false
              && this.props.existingAgreement.status !== EcoAgreementStatus.DELETED
              && this.props.existingAgreement.status !== EcoAgreementStatus.REJECTED)
              && <IconButton onClick={() => this.handleDelete()}><DeleteIcon style={{fill:styleColors.coral800}} /></IconButton>}
            {(this.props.existingAgreement !== undefined && this.props.existingAgreement.closed === false)
              && <ChatButton 
                    callBack={onClose}
                    chatId={this.props.existingAgreement.chatId}
                    family={this.props.family}
                    referenceObject={this.props.existingAgreement.id}
                    chatType={ChatType.AGREEMENT_CHAT}
                    waitForAgreementChat={this.props.waitForAgreementChat}
                    title={tn.lang.agreementRegardingTitle(this.props.existingAgreement.title)}
                    msg={tn.lang.agreementRegardingTitle(this.props.existingAgreement.title)}/>}
            <Button style={buttonContainedLarge} onClick={onClose} color='default' variant='outlined'>
         
              {tn.lang.cancel}
      
            </Button>
            <Button style={buttonContainedLarge} onClick={() => this.handleSubmit()}
              color='primary' variant='contained' disabled={this.state.saveClicked ||
              this.state.internalDataUrl.some(url => !this.state.loadedImageUrls.includes(url)) ||
              (values.title.trim().length < 2 
              || (this.props.existingAgreement !== undefined && 
              (this.props.existingAgreement.closed === true
                || this.props.existingAgreement.status === EcoAgreementStatus.DELETED
                || this.props.existingAgreement.status === EcoAgreementStatus.REJECTED)))}>
                       
              {buttonText}
             
            </Button>
          </Row>
      </Dialog>
      <Dialog
        open={this.state.showConfirmDelete}
        onClose={() => {this.setState({showConfirmDelete:false});}}
        fullWidth={true}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.confirmRepeatingDelete}</DialogTitle>
          <IconButton onClick={() => {this.setState({showConfirmDelete:false});}}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <Row style={{justifyContent: 'space-around', alignItems: 'center', padding: '0px 24px 20px'}}>
          <Button onClick={() => {this.setState({showConfirmDelete:false});}} color='default' variant='contained'>
            {tn.lang.cancel}
          </Button>
          
          {(this.props.existingAgreement 
            && this.props.existingAgreement.spawnedChild === false 
            && this.props.existingAgreement.repeat !== EcoRepeat.ONCE) 
            ?<Button onClick={() => {this.setState({showConfirmDelete:false}); this.handleConfirmDelete(false);}}
                color='default' variant='contained' >
                {tn.lang.confirmRepeatingDeleteThis}
              </Button>
            :<Button onClick={() => {this.setState({showConfirmDelete:false}); this.handleConfirmDelete(false);}}
              color='default' variant='contained' >
              {tn.lang.confirmRepeatingDeleteThisOne}
            </Button>}
          {(this.props.existingAgreement 
            && this.props.existingAgreement.spawnedChild === false 
            && this.props.existingAgreement.repeat !== EcoRepeat.ONCE) && 
            <Button onClick={() => {this.setState({showConfirmDelete:false}); this.handleConfirmDelete(true);}} 
              color='default' variant='contained'>
              {tn.lang.confirmRepeatingDeleteFuture}
            </Button>}
        </Row>
      </Dialog>
      <Dialog
        open={(this.state.zoomImage !== undefined)}
        onClose={() => {this.setState({zoomImage:undefined});}}
        fullWidth={true}
      >
        <DialogTop >
          <Col style={{flex:1, alignItems: 'center'}}>
            <DialogTitle>{fileTitle}</DialogTitle>
          </Col>
          <IconButton onClick={() => {this.setState({zoomImage:undefined});}}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <CustomDialogContent style={{position:'relative', padding:0}}>
          <img src={fileUrl} alt={fileTitle} style={{height:'auto'}}/>
        </CustomDialogContent>
        <Row style={{justifyContent: 'flex-end', padding: '20px'}}>
          <Button onClick={() => {this.setState({zoomImage:undefined});}} color='default' variant='contained' size="large">
            {tn.lang.done}
          </Button>
        </Row>
      </Dialog>
      </>
    );
  }
  private cleanup = () => {
    for (const file of this.props.uploadedFiles) {
      this.props.removeStoredFile(file.id);
    }
    for (const file of this.props.uploadingFiles) {
      this.props.removeStoredFile(file.id);
    }

  }

  private childrenDropdownData = () =>{
    const data: Array<{value:string, element:JSX.Element}> = [];
    data.push({value:"none", element:<ImgAvatar color="" imgName={0} style={{ width: 25, height: 25 }} 
      imgUrl={undefined} altText="None" grayed={true} />});
    for (const mem of this.props.family.filter((member) => member.role === FamilyMemberType.CHILD)) {
      data.push({value:(""+mem.id), element:this.getAvatar(mem, 25)});
    }
    data.push({value:"all", element:<>
      {this.props.family.filter((member) => member.role === FamilyMemberType.CHILD).slice(0,2).map((member, index) => 
        (this.getAvatar(member, 25, false, (index * -12.5))))}</>});

    return data;
  }

  private renderAddImageButton = (showImages:boolean, cordovaApp:boolean) => {
    
    if (!showImages && (this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length) === 0) {
      return (
      <>
        <label htmlFor="add-file-direct4">
          <input type="file" multiple={false} style = {{opacity:0, position:'absolute'}} 
            id={"add-file-direct4"} onChange={this.parseFile} accept="capture=camera,image/*"/>
          <div style={{backgroundColor: styleColors.white, pointerEvents: 'none', boxShadow: 'rgba(0, 0, 0, 0.07) 0px 2px 4px',
            borderRadius: '4px', padding: '12px'}}>
            <ImageOutlinedIcon />
          </div>
        </label>
      </>);
    }
    return (<StyledButton onClick={() => this.toggleImages()} 
      style={showImages?{backgroundColor: 'transparent', boxShadow: `inset 1px 1px 4px ${styleColors.greyDark2}`}
        :{backgroundColor: styleColors.white}}>
      <ImageOutlinedIcon />
    </StyledButton>);
  }

  private getSelectedChildrenOption = (childrens: number[]):string => {
    if (childrens.length > 1) {
      return 'all';
    }
    if (childrens.length === 1) {
      return (""+childrens[0]);
    }
    return "none";
  }

  private handleDelete = () => {
    if (this.props.existingAgreement !== undefined) {
      if (this.props.existingAgreement.repeat !== EcoRepeat.ONCE) {
        this.setState({showConfirmDelete:true});
      } else {
        this.handleConfirmDelete(false);
      }
    }
  }

  private handleConfirmDelete = (future:boolean) => {
    if (this.props.existingAgreement !== undefined) {
        this.props.onDelete(this.props.existingAgreement.id, future);
    }
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    this.setState((prevState: any) => ({
      values: {
        ...prevState.values,
        [name]: newValue,
      },
    }));
  }

  private handleSliderChange = (event: any, value: number | number[]) => {
    const myPayment = convertSliderValueToPercentage( (value as number) );
    this.updateSplit(myPayment);
  }

  private handlePercentageClick = (side: 'mine' | 'coparent') => {
    const mySplit = this.state.values.split.find((split) => split.accountId === this.props.userId);
    const myPayment = mySplit ? mySplit.percentage : 50;
    const nextMyPayment = side === 'mine'
      ? Math.min(myPayment + 1, 100)
      : Math.max(myPayment - 1, 0);

    this.updateSplit(nextMyPayment);
  }

  private updateSplit = (myPayment:number) => {
    const partnerTwoPayment = 100 - myPayment;
    const newSplit:IEcoSplit[] = [];
    for (const mem of this.props.family) {
      if (mem.id === this.props.userId) {
        newSplit.push({accountId:mem.id, percentage: myPayment});
      } else if (mem.role === FamilyMemberType.PARENT) {
        newSplit.push({accountId:mem.id, percentage: partnerTwoPayment});
      }
    }

    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        split: newSplit,
      },
    }));
  }

  private handleResponsibleChange = (accountId:number) => {

    this.setState((prevState) => {
      const { values } = prevState;

      let updatedResponsible: number[];
      if (!values.responsible.includes(accountId)) {
        updatedResponsible = [...values.responsible, accountId]; // Add the ID to the responsible list
      } else {
        updatedResponsible = values.responsible.filter((id) => id !== accountId); // Remove the ID from the responsible list
      }

      const updatedValues = {
        ...values,
        responsible: updatedResponsible,
      };

      return {
        values: updatedValues,
      };
    });
  }

  private handleChildrenChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let children: number[] = [];
    if (value === 'all') {
      children = this.props.family
        .filter((member) => member.role === FamilyMemberType.CHILD).map(member => member.id);
    } else if (value !== 'none') {
      children = [Number(value)];
    }

    this.setState((prevState: any) => ({
      values: {
        ...prevState.values,
        children,
      },
    }));
  }

  private handleSubmit = () => {

    if (this.editorRef1.current) {
      this.setState({saveClicked:true});
      this.upload(this.editorRef1.current,800,800);
    } else {
      this.save();
    }
  }

  private save = () => {
  
    const { values } = this.state;
    const images:number[] = [];
    const amount = this.state.setPrice?values.amount:0;
    for (const f of this.state.previousFiles) {
      if (f.id) {
        images.push(f.id);
      }
    }
    for (const f of this.props.uploadedFiles) {
      if (this.state.internalImages.includes(f.internalId)) {
        images.push(f.id);
        this.props.uploadedFileUsed(f.id);
      }
    }
    if (this.props.existingAgreement && this.props.existingAgreement.id) {
      const update:IUpdateEcoAgreement = {
        id:this.props.existingAgreement.id,
        chatId:this.props.existingAgreement.chatId,
        title:values.title,
        children:values.children,
        description:values.description,
        images,
        responsible:values.responsible,
        repeat:values.repeat,

        // will trigger a pending change
        amount,
        currency:values.currency,
        split:values.split,
      };
      this.props.onEdit(update);
    } else {
      this.props.onCreateNew({...this.state.values, images, amount, autoAccept:(!this.props.isRequest)});
    }
  
  }

  private upload(editorRef:AvatarEditor, maxWidth:number, maxHeight:number) {
    const canvas = document.createElement('canvas');

    if (editorRef === null) {
      return;
    }

    const im: HTMLCanvasElement = editorRef.getImage();

    if (!im) {
      return;
    }

    const w = im.width;
    const h = im.height;

    let newImgWidth = w;
    let newImgHeight = h;

    if (w >= h && w > maxWidth) {
        newImgWidth = maxWidth;
        newImgHeight = Math.floor((maxWidth * h) / w);
    } else if (h > w && h > maxHeight) {
        newImgHeight = maxHeight;
        newImgWidth = Math.floor((maxHeight * w) / h);
    }

    canvas.width = newImgWidth;
    canvas.height = newImgHeight;

    const context = canvas.getContext('2d');

    if (context !== null) {
      context.drawImage(editorRef.getImageScaledToCanvas(), 0, 0, newImgWidth, newImgHeight);
    }

    canvas.toBlob((blob) => {
      if(blob && editorRef){
        const d = handleBlobUpload(blob, "purchase.png", this.props.uploadFile);
        this.setState((prevstate) => {
          const internalImages = prevstate.internalImages.slice();
          internalImages.push(d.internalId);
          return {...prevstate, internalImages}})
      }
    })
  }

  private getAvatar(member: IFamilyMember, size: number = 30, grayed?: boolean, leftMargin?: number) {
    const image = member.avatar;
    const name = member.firstName;
    const color = member.color;
    const style: React.CSSProperties | undefined = { width: size, height: size, marginLeft: leftMargin };

    return <ImgAvatar key={member.id} color={color} imgName={image} style={style} altText={name} grayed={grayed} 
      imgUrl={member.imageAvatar?member.avatarURL:undefined}/>;
  }

  private toggleDescription = () => {
    this.setState((prevState) => ({
      showDescription: !prevState.showDescription,
    }));
  }

  private toggleImages = () => {
    this.setState((prevState) => ({
      showImages: !prevState.showImages,
    }));
  }

  private imageLoaded = (url:string) => {
    this.setState((prev) =>
      prev.loadedImageUrls.includes(url)
        ? prev
        : {...prev, loadedImageUrls:[...prev.loadedImageUrls, url]});
  }

  private imageLoadFailed = (url:string) => {
    this.setState((prev) => {
      const idx = prev.internalDataUrl.indexOf(url);
      if (idx === -1) {
        return prev;
      }
      const internalDataUrl = prev.internalDataUrl.slice();
      internalDataUrl.splice(idx, 1);
      const loadedImageUrls = prev.loadedImageUrls.filter(u => internalDataUrl.includes(u));
      return {...prev, internalDataUrl, loadedImageUrls};
    });
    this.props.displayErrorMessage("Could not read the selected image. Please try another image.");
  }

  private parseFile = async (event: any) => {
    try {
      const maxSelect = 3- (this.props.uploadingFiles.length + this.props.uploadedFiles.length + this.state.previousFiles.length);
      const { files } = event.target;
      if (maxSelect > 0 && files && files.length > 0 || (event.files && event.files.length > 0)) {
        const f:File = files.item(0) ? files.item(0) : event.files.item(0);
        if (f.type && f.type.toLowerCase().includes("image")) {
          const data = await fileToBase64(f);
          const internalDataUrl = this.state.internalDataUrl.slice();
          internalDataUrl.push('data:'+f.type+';base64,'+ data);
          this.setState({internalDataUrl, showImages:true});
        } else if (f.type && f.type.toLowerCase().includes("video")) {
          this.props.displayErrorMessage("Videos not supported yet");
        }
      }
    } catch (error) {
      console.error("Failed to read selected agreement image", error);
      this.props.displayErrorMessage("Could not read the selected image. Please try another image.");
    }
  }


  private removeImage = (file:number, removeOnServer:boolean) => {
    if (removeOnServer) {
      this.props.removeStoredFile(file);
    }
    this.setState({previousFiles:this.state.previousFiles.filter((f) => f.id !== file)});
  }
}

function mapStateToProps(state: any) {
  const userId = state.user.session.data.id;

  return {
    userId,
    family: state.family.family,
    uploadingFiles: state.file.uploadSlots,
    uploadedFiles: state.file.uploadedFiles,
  };
}

const mapDispatchToProps = {
  uploadFile: FileActions.requestFileUpload,
  uploadedFileUsed: FileActions.uploadedFileUsed,
  removeStoredFile: FileActions.removeStoredFile,
  displayErrorMessage,
};


AgreementDialog.contextType = CordovaContext;

export default connect(mapStateToProps,mapDispatchToProps)(withStyles(dialogStyles)(AgreementDialog));



// WEBPACK FOOTER //
// ./src/components/economy/AgreementDialog.tsx